
import { Link } from "react-router-dom";

/** هر index یک رنگ — بدون تکرار تا ۱۲ تخصص */
const PALETTES = [
	{
		tile: "bg-gradient-to-br from-[#E8F3FC] via-[#D4E8F8] to-[#B8D9F0]",
		border: "border-[#A8CCE8]/80 group-hover:border-darkBlue/35",
		shadow: "shadow-[0_8px_20px_rgba(39,106,166,0.12)] group-hover:shadow-[0_12px_28px_rgba(39,106,166,0.18)]",
	},
	{
		tile: "bg-gradient-to-br from-[#FFF0EA] via-[#FFE4D9] to-[#FFD0BC]",
		border: "border-[#FFCBB8]/90 group-hover:border-cta/40",
		shadow: "shadow-[0_8px_20px_rgba(255,106,75,0.1)] group-hover:shadow-[0_12px_28px_rgba(255,106,75,0.16)]",
	},
	{
		tile: "bg-gradient-to-br from-[#EAF8F2] via-[#D8F2E8] to-[#BEE8D4]",
		border: "border-[#A8DFC8]/85 group-hover:border-secondary-green2/45",
		shadow: "shadow-[0_8px_20px_rgba(52,215,173,0.1)] group-hover:shadow-[0_12px_28px_rgba(37,179,143,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#F2EEFF] via-[#E6DEFF] to-[#D4C8F5]",
		border: "border-[#C9BBF0]/85 group-hover:border-[#8B7AE8]/45",
		shadow: "shadow-[0_8px_20px_rgba(107,91,212,0.1)] group-hover:shadow-[0_12px_28px_rgba(107,91,212,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#FFF8E6] via-[#FFEFCC] to-[#FFE4A3]",
		border: "border-[#F5D88A]/85 group-hover:border-[#D4A017]/40",
		shadow: "shadow-[0_8px_20px_rgba(212,160,23,0.1)] group-hover:shadow-[0_12px_28px_rgba(212,160,23,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#FFEDF2] via-[#FFDEE8] to-[#FFC8D8]",
		border: "border-[#F5B8CC]/85 group-hover:border-[#E85A8A]/40",
		shadow: "shadow-[0_8px_20px_rgba(232,90,138,0.1)] group-hover:shadow-[0_12px_28px_rgba(232,90,138,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#E5F7FA] via-[#C8EEF2] to-[#A8E0E8]",
		border: "border-[#8FD0DC]/85 group-hover:border-[#3BA8BC]/40",
		shadow: "shadow-[0_8px_20px_rgba(59,168,188,0.1)] group-hover:shadow-[0_12px_28px_rgba(59,168,188,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#ECEEF8] via-[#D8DCF0] to-[#BEC5E4]",
		border: "border-[#A8B2D8]/85 group-hover:border-[#5C6BC0]/40",
		shadow: "shadow-[0_8px_20px_rgba(92,107,192,0.1)] group-hover:shadow-[0_12px_28px_rgba(92,107,192,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#F0FAE8] via-[#E0F2D0] to-[#C8E4B0]",
		border: "border-[#B8D898]/85 group-hover:border-[#7CB342]/40",
		shadow: "shadow-[0_8px_20px_rgba(124,179,66,0.1)] group-hover:shadow-[0_12px_28px_rgba(124,179,66,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#FAF0E8] via-[#F0E0D4] to-[#E0C8B8]",
		border: "border-[#D4B8A8]/85 group-hover:border-[#A1887F]/40",
		shadow: "shadow-[0_8px_20px_rgba(161,136,127,0.1)] group-hover:shadow-[0_12px_28px_rgba(161,136,127,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#E8FCF8] via-[#C8F5EC] to-[#98E8D8]",
		border: "border-[#78D8C8]/85 group-hover:border-[#26A69A]/40",
		shadow: "shadow-[0_8px_20px_rgba(38,166,154,0.1)] group-hover:shadow-[0_12px_28px_rgba(38,166,154,0.14)]",
	},
	{
		tile: "bg-gradient-to-br from-[#F5E8FC] via-[#E8D4F8] to-[#D4B8F0]",
		border: "border-[#C49AE8]/85 group-hover:border-[#9C27B0]/35",
		shadow: "shadow-[0_8px_20px_rgba(156,39,176,0.1)] group-hover:shadow-[0_12px_28px_rgba(156,39,176,0.14)]",
	},
];

export function paletteFor(index) {
	if (index >= 0 && index < PALETTES.length) {
		return PALETTES[index];
	}
	return PALETTES[index % PALETTES.length];
}

const shellClass =
	"group flex flex-col items-center text-center no-underline py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-darkBlue/25 rounded-lg";

export default function ExpertiseTile({
	expertise,
	isDesktop,
	index = 0,
	to,
	onClick,
	isSelected = false,
}) {
	const palette = paletteFor(index);
	const size = isDesktop ? "w-[84px] h-[84px]" : "w-[72px] h-[72px]";

	const body = (
		<>
			<div
				className={[
					"relative shrink-0 overflow-hidden",
					"rounded-[18px] md:rounded-[20px]",
					"border transition-all duration-200",
					"group-hover:scale-[1.04] group-hover:-translate-y-0.5",
					isSelected ? "ring-2 ring-cta ring-offset-2 border-cta/50" : "",
					palette.tile,
					palette.border,
					palette.shadow,
					size,
				].join(" ")}
			>
				<div
					className="absolute inset-0 bg-gradient-to-t from-white/25 to-white/0 pointer-events-none"
					aria-hidden
				/>
				{expertise.image_url ? (
					<img
						src={expertise.image_url}
						alt=""
						className={[
							"expertise-home-icon",
							"absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
							"w-[108%] h-[108%] max-w-none object-contain",
							"pointer-events-none select-none",
						].join(" ")}
					/>
				) : (
					<div className="w-full h-full bg-white/25" />
				)}
			</div>

			<span
				className={[
					"mt-2.5 md:mt-3 font-Vazir-600 leading-relaxed line-clamp-2 max-w-[5.5rem] md:max-w-[6.5rem]",
					"text-midGray group-hover:text-darkBlue transition-colors",
					isDesktop ? "text-[14px]" : "text-[11px]",
					isSelected ? "text-darkBlue" : "",
				].join(" ")}
			>
				{expertise.name}
			</span>
		</>
	);

	if (to && !onClick) {
		return (
			<Link to={to} className={shellClass}>
				{body}
			</Link>
		);
	}

	return (
		<button
			type="button"
			onClick={onClick}
			className={`${shellClass} border-0 bg-transparent cursor-pointer p-0 w-full`}
		>
			{body}
		</button>
	);
}
